import React, { useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCirclePlay,
  faStar,
  faArrowRight,
  faUsers,
  faTrophy,
} from "@fortawesome/free-solid-svg-icons";
import HoldingBooksImg from "../../../Assets/Images/Home_Img_Banner.png";
import HomeCarasolImg1 from "../../../Assets/Home-Carasol-1.jpg";
import HomeCarasolImg3 from "../../../Assets/Home-Carasol-2.jpg";
import HomeCarasolImg2 from "../../../Assets/Home-Carasol-3.jpg";
import StudentImg1 from "../../../Assets/Images/Home_Image1.png";
import StudentImg2 from "../../../Assets/Images/Home_Image2.png";
import StudentImg4 from "../../../Assets/Images/Home_Image3.png";
import StudentImg3 from "../../../Assets/Images/Home_Image4.png";
import ContactModal from "./ContactModal";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

const LearningExcellence = () => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [current, setCurrent] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [currentTranslate, setCurrentTranslate] = useState(0);
  const [prevTranslate, setPrevTranslate] = useState(0);
  // const sectionRef = useRef(null);
  const carouselRef = useRef(null);

  const navigate = useNavigate();
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
      offset: 50,
      delay: 0,
      easing: "ease-out",
      disable: "mobile",
    });
    AOS.refresh();
  }, []);

  const testimonials = [
    { image: HoldingBooksImg },
    { image: HomeCarasolImg1 },
    { image: HomeCarasolImg2 },
    { image: HomeCarasolImg3 },
  ];

  const handleTouchStart = (e) => {
    setIsDragging(true);
    setStartX(getClientX(e));
    setPrevTranslate(currentTranslate);
  };

  const handleTouchMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();

    const currentX = getClientX(e);
    const diff = currentX - startX;
    setCurrentTranslate(prevTranslate + diff);
  };

  const handleTouchEnd = () => {
    if (!isDragging) return;
    setIsDragging(false);

    const movedBy = currentTranslate - prevTranslate;
    const carouselWidth = carouselRef.current?.offsetWidth || 0;

    // Change slide if dragged more than 50px
    if (Math.abs(movedBy) > 50) {
      if (movedBy > 0) {
        // Dragged right - go to previous slide
        setCurrent((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
      } else {
        // Dragged left - go to next slide
        setCurrent((prev) => (prev + 1) % testimonials.length);
      }
    }

    setCurrentTranslate(-current * (carouselWidth || 0));
  };

  const getClientX = (e) => {
    return e.type.includes("mouse") ? e.clientX : e.touches[0].clientX;
  };

  // Update translate when current changes
  useEffect(() => {
    const carouselWidth = carouselRef.current?.offsetWidth || 0;
    setCurrentTranslate(-current * carouselWidth);
    setPrevTranslate(-current * carouselWidth);
  }, [current]);

  // auto slide - pause when dragging
  useEffect(() => {
    if (isDragging) return;

    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [testimonials.length, isDragging]);

  // trigger cursor drag mode only over this section
  // useEffect(() => {
  //   const section = carouselRef.current;

  //   const handleEnter = () => window.dispatchEvent(new Event("enter-drag-mode"));
  //   const handleLeave = () => window.dispatchEvent(new Event("leave-drag-mode"));

  //   section.addEventListener("mouseenter", handleEnter);
  //   section.addEventListener("mouseleave", handleLeave);

  //   return () => {
  //     section.removeEventListener("mouseenter", handleEnter);
  //     section.removeEventListener("mouseleave", handleLeave);
  //   };
  // }, []);

  // Add event listeners for mouse events
  useEffect(() => {
    const carousel = carouselRef.current;
    if (!carousel) return;

    const handleMouseDown = (e) => handleTouchStart(e);
    const handleMouseMove = (e) => handleTouchMove(e);
    const handleMouseUp = () => handleTouchEnd();
    const handleMouseLeave = () => {
      if (isDragging) handleTouchEnd();
    };

    carousel.addEventListener("mousedown", handleMouseDown);
    carousel.addEventListener("mousemove", handleMouseMove);
    carousel.addEventListener("mouseup", handleMouseUp);
    carousel.addEventListener("mouseleave", handleMouseLeave);

    return () => {
      carousel.removeEventListener("mousedown", handleMouseDown);
      carousel.removeEventListener("mousemove", handleMouseMove);
      carousel.removeEventListener("mouseup", handleMouseUp);
      carousel.removeEventListener("mouseleave", handleMouseLeave);
    };
  }, [isDragging, startX, currentTranslate, prevTranslate]);

  return (
    <React.Fragment>
      <section className="relative lg:h-[600px] h-full flex flex-col lg:flex-row text-center lg:text-start justify-between items-center bg-gradient-to-br from-[#DA3335] via-[#1b0a0a] to-[#144982] mx-3 sm:mx-4 xl:mx-6 2xl:mx-10 my-3 px-4 sm:px-6 md:px-8 lg:px-20 xl:px-16 2xl:px-28 rounded-lg gap-4 lg:gap-8 shadow-[0_0_40px_rgba(218,51,53,0.4)] overflow-hidden">
        {/* Animated Background Elements */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-10 left-10 w-72 h-72 bg-red-500/10 rounded-full blur-3xl animate-pulse"></div>
          <div className="absolute bottom-10 right-10 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl animate-pulse delay-700"></div>
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full h-full">
            <div className="absolute top-20 right-20 w-2 h-2 bg-white/30 rounded-full animate-ping"></div>
            <div className="absolute bottom-32 left-32 w-2 h-2 bg-white/30 rounded-full animate-ping delay-500"></div>
            <div className="absolute top-40 left-40 w-1 h-1 bg-white/40 rounded-full animate-pulse"></div>
          </div>
        </div>

        {/* Content Section */}
        <div
          data-aos="fade-right"
          className="relative flex-1 w-full lg:max-w-2xl space-y-8"
        >
          {/* Badge */}
          <div className="hidden lg:inline-flex  items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2">
            <FontAwesomeIcon
              icon={faStar}
              className="text-yellow-400 text-sm"
            />
            <span className="text-white text-xs sm:text-sm font-semibold heading tracking-wide">
              Premium Learning Experience
            </span>
          </div>

          <h1 className="text-white text-3xl sm:text-4xl md:text-5xl lg:text-5xl xl:text-7xl font-extrabold leading-tight mb-2 sm:mb-3 md:mb-4 drop-shadow-2xl heading">
            Elevate Your <br className="hidden sm:block" />
            <span className="bg-gradient-to-r from-white via-red-200 to-blue-200 bg-clip-text text-transparent">
              Fashion
            </span>
          </h1>

          <p className="text-white/90 text-xs sm:text-sm md:text-base lg:text-lg leading-5 sm:leading-6 md:leading-7 mb-4 sm:mb-6 text-center lg:text-left max-w-2xl mx-auto lg:mx-0 drop-shadow-lg tracking-wider heading">
            Discover timeless styles that define your personality and
            confidence. From contemporary streetwear to elegant classics, we
            bring trends that inspire your everyday look and redefine fashion
            for every occasion.
          </p>

          {/* CTA Buttons */}
          <ul className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-2 sm:gap-3 mt-0">
            <button
              className="heading group relative bg-white text-[#DA3335] text-base sm:text-lg md:text-xl font-bold px-8 sm:px-5 md:px-6 py-3 sm:py-2 md:py-3 rounded-full hover:bg-opacity-95 transition-all duration-300 inline-flex items-center gap-3 shadow-[0_10px_30px_rgba(255,255,255,0.3)] hover:shadow-[0_15px_40px_rgba(255,255,255,0.4)] hover:scale-105"
              onClick={() => navigate("/explore-courses")}
            >
              Explore Courses
              <FontAwesomeIcon
                icon={faArrowRight}
                className="transition-transform group-hover:translate-x-1"
              />
            </button>
            <button
              onClick={() => setIsContactModalOpen(true)}
              className="heading group bg-transparent text-white text-base sm:text-lg md:text-xl font-bold px-8 sm:px-5 md:px-6 py-3 sm:py-2 md:py-3 rounded-full border-2 border-white/30 hover:border-white/60 backdrop-blur-sm transition-all duration-300 inline-flex items-center gap-3 hover:bg-white/10"
            >
              Inquiry now
              <FontAwesomeIcon
                icon={faArrowRight}
                className="transition-transform group-hover:translate-x-1"
              />
            </button>
          </ul>
        </div>

        {/* Image Section */}
        <div
          data-aos="fade-left"
          className="relative w-full lg:w-auto lg:flex-shrink-0 mt-0 z-10 flex justify-center items-center  "
        >
          <div className="relative overflow-hidden rounded-2xl max-w-2xl mx-auto lg:mx-0 shadow-[0_20px_60px_rgba(0,0,0,0.5)] border-4 border-white/20 hover:border-white/40 transition-all duration-500 group">
            {/* Glowing Border Effect */}
            <div className="absolute inset-0 bg-gradient-to-r from-red-500/20 via-purple-500/20 to-blue-500/20 rounded-2xl blur-xl group-hover:blur-2xl transition-all duration-500"></div>

            <div
              ref={carouselRef}
              className="flex md:w-[550px] lg:w-[500px] xl:w-full "
              style={{
                transform: `translateX(${currentTranslate}px)`,
                transition: isDragging ? "none" : "transform 0.3s ease-out",
              }}
            >
              {testimonials.map((item, idx) => (
                <div className=" w-full flex-shrink-0 ">
                  <img
                    src={item.image}
                    alt="Fashion Banner"
                    className="relative lg:w-[500px] xl:w-full w-auto h-[250px] sm:h-[350px] md:h-[400px] lg:h-[450px] xl:h-[500px] object-cover rounded-2xl transform group-hover:scale-1.02 transition-transform duration-700 overflow-hidden"
                  />
                </div>
              ))}
            </div>

            {/* Overlay Gradient */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent rounded-2xl"></div>

            {/* Floating Badge */}
            <div className="absolute top-4 right-4 bg-white/95 backdrop-blur-sm rounded-full px-4 py-2 shadow-lg animate-bounce heading">
              <div className="flex items-center gap-2">
                <FontAwesomeIcon icon={faStar} className="text-yellow-500" />
                <span className="text-sm font-bold text-gray-800">
                  Top Rated
                </span>
              </div>
            </div>
          </div>

          {/* Floating Student Card */}
          <div className="absolute   bottom-2  lg:-bottom-6 -left-4 sm:-left-6 lg:left-4 bg-white/95 backdrop-blur-md shadow-2xl rounded-2xl px-2 sm:px-6 py-2 md:py-4 max-w-xs border border-white/50 animate-float ">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-6 h-6 md:w-10 md:h-10 bg-gradient-to-br from-[#DA3335] to-[#144982] rounded-full flex items-center justify-center">
                <FontAwesomeIcon
                  icon={faUsers}
                  className="text-white text-sm"
                />
              </div>
              <div className="text-left heading">
                <h3 className="text-sm sm:text-xl font-bold text-gray-800">
                  2000+ Students
                </h3>
                <p className="text-xs text-gray-600">Join our community</p>
              </div>
            </div>

            {/* Student Avatars */}
            <div className="flex flex-col md:flex-row  items-center">
              <div className="flex -space-x-2">
                <div className="w-6 h-6 md:w-8 md:h-8 rounded-full bg-gradient-to-br from-pink-400 to-purple-600 border-2 border-white">
                  <img src={StudentImg1} alt="" />
                </div>
                <div className="w-6 h-6 md:w-8 md:h-8 rounded-full bg-gradient-to-br from-blue-400 to-cyan-600 border-2 border-white">
                  <img src={StudentImg2} alt="" />
                </div>
                <div className="w-6 h-6 md:w-8 md:h-8 rounded-full bg-gradient-to-br from-green-400 to-emerald-600 border-2 border-white">
                  <img src={StudentImg3} alt="" />
                </div>
                <div className="w-6 h-6 md:w-8 md:h-8 rounded-full bg-gradient-to-br from-orange-400 to-red-600 border-2 border-white">
                  <img src={StudentImg4} alt="" />
                </div>
                <div className="w-6 h-6 md:w-8 md:h-8 rounded-full bg-gradient-to-br from-yellow-400 to-orange-600 border-2 border-white flex items-center justify-center text-xs font-bold text-white">
                  +5
                </div>
              </div>
              <span className="ml-3 text-xs text-gray-600 font-medium">
                and many more...
              </span>
            </div>
          </div>
        </div>

        <style jsx>{`
          @keyframes float {
            0%,
            100% {
              transform: translateY(0px);
            }
            50% {
              transform: translateY(-10px);
            }
          }
          .animate-float {
            animation: float 3s ease-in-out infinite;
          }
          .delay-500 {
            animation-delay: 500ms;
          }
          .delay-700 {
            animation-delay: 700ms;
          }
        `}</style>
      </section>

      <ContactModal
        isOpen={isContactModalOpen}
        onClose={() => setIsContactModalOpen(false)}
      />
    </React.Fragment>
  );
};

export default LearningExcellence;

// import React, { useState } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faCirclePlay,
//   faStar,
//   faArrowRight,
//   faUsers,
//   faTrophy,
// } from "@fortawesome/free-solid-svg-icons";
// import HoldingBooksImg from "../../../Assets/Images/Home_Img_Banner.png";
// import StudentImg1 from "../../../Assets/Images/Home_Image1.png";
// import StudentImg2 from "../../../Assets/Images/Home_Image2.png";
// import StudentImg4 from "../../../Assets/Images/Home_Image3.png";
// import StudentImg3 from "../../../Assets/Images/Home_Image4.png";
// import ContactModal from "./ContactModal";

// const LearningExcellence = () => {
//   const [isContactModalOpen, setIsContactModalOpen] = useState(false);

//   return (
//     <React.Fragment>
//       <section className="relative  flex flex-col lg:flex-row text-center lg:text-start justify-between items-center lg:items-start bg-gradient-to-br from-[#DA3335] via-[#1b0a0a] to-[#144982] mx-3 sm:mx-4 xl:mx-6 2xl:mx-10 my-3 px-4 sm:px-6 md:px-8 lg:px-10 xl:px-16 2xl:px-28 py-12 sm:py-14 md:py-16 lg:py-20 xl:py-24 rounded-lg gap-8 lg:gap-12 shadow-[0_0_40px_rgba(218,51,53,0.4)] overflow-hidden">
//         {/* Animated Background Elements */}
//         <div className="absolute inset-0 overflow-hidden pointer-events-none">
//           <div className="absolute top-10 left-10 w-72 h-72 bg-red-500/10 rounded-full blur-3xl animate-pulse"></div>
//           <div className="absolute bottom-10 right-10 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl animate-pulse delay-700"></div>
//           <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full h-full">
//             <div className="absolute top-20 right-20 w-2 h-2 bg-white/30 rounded-full animate-ping"></div>
//             <div className="absolute bottom-32 left-32 w-2 h-2 bg-white/30 rounded-full animate-ping delay-500"></div>
//             <div className="absolute top-40 left-40 w-1 h-1 bg-white/40 rounded-full animate-pulse"></div>
//           </div>
//         </div>

//         {/* Content Section */}
//         <div className="relative flex-1 w-full lg:max-w-2xl z-10 ">
//           {/* Badge */}
//           <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2 mb-4 sm:mb-5">
//             <FontAwesomeIcon
//               icon={faStar}
//               className="text-yellow-400 text-sm"
//             />
//             <span className="text-white text-xs sm:text-sm font-semibold">
//               Premium Learning Experience
//             </span>
//           </div>

//           <h1 className="text-white text-4xl sm:text-5xl md:text-6xl lg:text-6xl xl:text-7xl 2xl:text-8xl font-extrabold leading-tight mb-4 sm:mb-5 md:mb-6 lg:mb-8 drop-shadow-2xl">
//             Elevate Your <br className="hidden sm:block" />
//             <span className="bg-gradient-to-r from-white via-red-200 to-blue-200 bg-clip-text text-transparent">
//               Fashion
//             </span>
//           </h1>

//           <p className="text-white/90 text-sm sm:text-base lg:text-lg xl:text-xl leading-6 sm:leading-7 lg:leading-8 mb-8 sm:mb-10 md:mb-12 lg:mb-12 text-center lg:text-left max-w-2xl mx-auto lg:mx-0 drop-shadow-lg">
//             Discover timeless styles that define your personality and
//             confidence. From contemporary streetwear to elegant classics, we
//             bring trends that inspire your everyday look and redefine fashion
//             for every occasion.
//           </p>

//           {/* CTA Buttons */}
//           <ul className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 sm:gap-6 mt-2">
//             <li>
//               <a
//                 className="group relative bg-white text-[#DA3335] text-base sm:text-lg md:text-xl font-bold px-8 sm:px-10 md:px-12 py-3 sm:py-4 md:py-5 rounded-full hover:bg-opacity-95 transition-all duration-300 inline-flex items-center gap-3 shadow-[0_10px_30px_rgba(255,255,255,0.3)] hover:shadow-[0_15px_40px_rgba(255,255,255,0.4)] hover:scale-105"
//                 href="/"
//               >
//                 Explore Courses
//                 <FontAwesomeIcon
//                   icon={faArrowRight}
//                   className="transition-transform group-hover:translate-x-1"
//                 />
//               </a>
//             </li>
//             <button
//               onClick={() => setIsContactModalOpen(true)}
//               className="group bg-transparent text-white text-base sm:text-lg md:text-xl font-bold px-8 sm:px-10 md:px-12 py-3 sm:py-4 md:py-5 rounded-full border-2 border-white/30 hover:border-white/60 backdrop-blur-sm transition-all duration-300 inline-flex items-center gap-3 hover:bg-white/10"
//             >
//               Inquiry now
//               <FontAwesomeIcon
//                 icon={faArrowRight}
//                 className="transition-transform group-hover:translate-x-1"
//               />
//             </button>
//           </ul>
//         </div>

//         {/* Image Section */}
//         <div className="relative w-full lg:w-auto lg:flex-shrink-0 mt-8 sm:mt-10 md:mt-12 lg:mt-0 z-10">
//           <div className="relative overflow-hidden rounded-2xl max-w-2xl mx-auto lg:mx-0 shadow-[0_20px_60px_rgba(0,0,0,0.5)] border-4 border-white/20 hover:border-white/40 transition-all duration-500 group">
//             {/* Glowing Border Effect */}
//             <div className="absolute inset-0 bg-gradient-to-r from-red-500/20 via-purple-500/20 to-blue-500/20 rounded-2xl blur-xl group-hover:blur-2xl transition-all duration-500"></div>

//             <img
//               src={HoldingBooksImg}
//               alt="Fashion Banner"
//               className="relative w-full h-[250px] sm:h-[350px] md:h-[400px] lg:h-[300px] xl:h-[600px] object-cover rounded-2xl transform group-hover:scale-105 transition-transform duration-700"
//             />

//             {/* Overlay Gradient */}
//             <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent rounded-2xl"></div>

//             {/* Floating Badge */}
//             <div className="absolute top-4 right-4 bg-white/95 backdrop-blur-sm rounded-full px-4 py-2 shadow-lg animate-bounce">
//               <div className="flex items-center gap-2">
//                 <FontAwesomeIcon icon={faStar} className="text-yellow-500" />
//                 <span className="text-sm font-bold text-gray-800">
//                   Top Rated
//                 </span>
//               </div>
//             </div>
//           </div>

//           {/* Floating Student Card */}
//           <div className="absolute -bottom-6 -left-4 sm:-left-6 lg:left-4 bg-white/95 backdrop-blur-md shadow-2xl rounded-2xl px-4 sm:px-6 py-4 max-w-xs border border-white/50 animate-float">
//             <div className="flex items-center gap-3 mb-3">
//               <div className="w-10 h-10 bg-gradient-to-br from-[#DA3335] to-[#144982] rounded-full flex items-center justify-center">
//                 <FontAwesomeIcon
//                   icon={faUsers}
//                   className="text-white text-sm"
//                 />
//               </div>
//               <div className="text-left">
//                 <h3 className="text-lg sm:text-xl font-bold text-gray-800">
//                   2000+ Students
//                 </h3>
//                 <p className="text-xs text-gray-600">Join our community</p>
//               </div>
//             </div>

//             {/* Student Avatars */}
//             <div className="flex items-center">
//               <div className="flex -space-x-2">
//                 <div className="w-8 h-8 rounded-full bg-gradient-to-br from-pink-400 to-purple-600 border-2 border-white">
//                   <img src={StudentImg1} alt="" />
//                 </div>
//                 <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-400 to-cyan-600 border-2 border-white">
//                   <img src={StudentImg2} alt="" />
//                 </div>
//                 <div className="w-8 h-8 rounded-full bg-gradient-to-br from-green-400 to-emerald-600 border-2 border-white">
//                   <img src={StudentImg3} alt="" />
//                 </div>
//                 <div className="w-8 h-8 rounded-full bg-gradient-to-br from-orange-400 to-red-600 border-2 border-white">
//                   <img src={StudentImg4} alt="" />
//                 </div>
//                 <div className="w-8 h-8 rounded-full bg-gradient-to-br from-yellow-400 to-orange-600 border-2 border-white flex items-center justify-center text-xs font-bold text-white">
//                   +5
//                 </div>
//               </div>
//               <span className="ml-3 text-xs text-gray-600 font-medium">
//                 and many more...
//               </span>
//             </div>
//           </div>
//         </div>

//         <style jsx>{`
//           @keyframes float {
//             0%,
//             100% {
//               transform: translateY(0px);
//             }
//             50% {
//               transform: translateY(-10px);
//             }
//           }
//           .animate-float {
//             animation: float 3s ease-in-out infinite;
//           }
//           .delay-500 {
//             animation-delay: 500ms;
//           }
//           .delay-700 {
//             animation-delay: 700ms;
//           }
//         `}</style>
//       </section>
//       <ContactModal
//         isOpen={isContactModalOpen}
//         onClose={() => setIsContactModalOpen(false)}
//       />
//     </React.Fragment>
//   );
// };

// export default LearningExcellence;
